import { defineComponent as u } from "vue";
import { mapKeys as m, upperFirst as n, pickBy as d, camelCase as f } from "lodash-es";
const i = (e, o) => {
  Object.keys(o).forEach((p) => {
    (e[p] === void 0 || e[p] === null || e[p] === "") && (e[p] = o[p]);
  });
};
function l(e, o, p = {}) {
  const t = new RegExp(`^${o}`, "i");
  return u({
    props: {
      // @ts-ignore
      ...m(e.props, (c, r) => `${o}${n(r)}`)
    },
    computed: {
      [`mapped${n(o)}Props`]() {
        const c = d(this.$props, (a, s) => s.match(t)), r = m(
          c,
          (a, s) => f(s.replace(t, ""))
        );
        return i(r, p), r;
      }
    }
  });
}
export {
  l as useMappedPropsOptions
};
